import { render, staticRenderFns } from "./DegreeLevel.vue?vue&type=template&id=44085e0f&scoped=true&"
import script from "./DegreeLevel.vue?vue&type=script&lang=js&"
export * from "./DegreeLevel.vue?vue&type=script&lang=js&"
import style0 from "./DegreeLevel.vue?vue&type=style&index=0&id=44085e0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44085e0f",
  null
  
)

export default component.exports